import { useCallback, useEffect, useRef } from 'react'
import useCurrentActivity from '@renderer/overlay/Assistant/hooks/useCurrentActivity.tsx'

export const useActivityHandler = () => {
  const { activity, clearActivity } = useCurrentActivity()
  const previousActivityRef = useRef<string>()
  const timeoutRef = useRef<NodeJS.Timeout>()

  const clearActivityIfEligible = useCallback(
    (activity?: string) => {
      if (activity === 'clipboard' || activity === 'image' || activity === 'selectedText') {
        clearActivity(activity)
      }
    },
    [clearActivity],
  )

  useEffect(() => {
    const previous = previousActivityRef.current

    if (previous === activity) {
      return
    }

    // Update previous activity
    previousActivityRef.current = activity

    // clear previous activity if it was auto detected + activity changed
    clearActivityIfEligible(previous)

    // if the new activity is auto detected
    if (activity === 'clipboard' || activity === 'image' || activity === 'selectedText') {
      // wait 5s, and then clear the activity
      clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => {
        clearActivity(activity)
      }, 5000)
    }

    const currentActivity = activity
    return () => {
      if (timeoutRef.current && currentActivity !== activity) {
        clearTimeout(timeoutRef.current)
        timeoutRef.current = undefined
        clearActivityIfEligible(activity)
      }
    }
  }, [activity, clearActivity, clearActivityIfEligible])
}
